import React from 'react'
import Image from 'next/image'

import { BookCollectionPrivacyEnum } from '@interfaces/BookCollectionPrivacyEnum'
import { DeleteBinIcon } from '@components/icons/DeleteBinIcon'
import { EditeIcon } from '@components/icons/EditeIcon'
import { PrivateIcon } from '@components/icons/PrivateIcon'
import { PublicIcon } from '@components/icons/PublicIcon'
import { BookCollectionProps } from './interface'

export function BookCollection({
  collectionName,
  dataTest,
  privacyType,
  books,
  canEdit,
  canDelete,
  onEdit,
  onDelete,
  goToBookCollectionDetail,
}: BookCollectionProps) {
  return (
    <div
      data-test={dataTest}
      className='cursor-pointer'
      onClick={goToBookCollectionDetail}
    >
      <div className='flex w-[276px] tablet-mobile:w-[348px] space-x-[10px] p-[10px] rounded-[8px] bg-gray-4 dark:bg-dark-9'>
        {books.slice(0, 2).map(book => (
          <div className='rounded-[8px] w-[92px] mobile:w-[123px] overflow-hidden'>
            <div key={book.id} className='relative w-full pt-[141.30%]'>
              {book.coverImgPath ? (
                <Image
                  className='rounded-[8px]'
                  src={book.coverImgPath}
                  layout='fill'
                  alt='Book cover'
                  blurDataURL={book.coverImgPath}
                />
              ) : (
                <div className='absolute inset-0 bg-gray-3' />
              )}
            </div>
          </div>
        ))}
        {books.length > 2 && (
          <div className='self-center flex-1 text-[18px] mobile:text-[24px] text-secondary-1 font-bold text-center'>
            +{books.length - 2}
          </div>
        )}
      </div>
      <div className='flex justify-between mt-[10px]'>
        <div className='flex font-mitr text-secondary dark:text-dark-10 space-x-[5px] tablet-mobile:w-[250px] items-center'>
          {privacyType === BookCollectionPrivacyEnum.PRIVATE ? (
            <PrivateIcon
              className='text-primary min-w-[24px]'
              width='24'
              height='24'
            />
          ) : (
            <PublicIcon
              className='text-primary min-w-[24px]'
              width='24'
              height='24'
            />
          )}

          <span data-test='title' className='line-clamp-1 leading-7 break-all'>
            {collectionName}
          </span>
        </div>
        <div className='flex space-x-[10px] ml-[5px]'>
          {canEdit && (
            <button
              data-test='edit-button'
              type='button'
              className='border border-gray-3 dark:border-purple bg-white dark:bg-transparent rounded-[8px] px-[5px] h-[30px]'
              onClick={event => {
                event.stopPropagation()
                if (onEdit) {
                  onEdit()
                }
              }}
            >
              <EditeIcon
                width='20'
                height='20'
                className='text-secondary-1 dark:text-dark-10'
              />
            </button>
          )}
          {canDelete && (
            <button
              data-test='remove-button'
              type='button'
              className=' border border-gray-3 dark:border-purple bg-white dark:bg-transparent rounded-[8px] px-[5px] h-[30px]'
              onClick={event => {
                event.stopPropagation()
                if (onDelete) {
                  onDelete()
                }
              }}
            >
              <DeleteBinIcon
                width='20'
                height='20'
                className='text-secondary-1 dark:text-dark-10'
              />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
